/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import type { TypescriptHelpersT } from '@elliemae/ds-typescript-helpers';
import type { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../constants/index.js';
import type { DSLeftNavigationT } from '../index.js';

const SlotPropsAsObject: Partial<DSLeftNavigationT.Props> = {
  dsLeftnavigationAlertsIcon: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationAreasContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationArrowContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationBodyAreasContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationBodyHeaderArea: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationBodyItemsArea: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationBottomContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationCollapsedContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationExceptionsIcon: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationFooterItem: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationFooterLabel: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationFooterMenu: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationFooterMenuCollapse: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationFooterSeparator: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationHeaderArea: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItem: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItemBorderBottom: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItemChevronBack: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItemDate: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItemLabel: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationItemSeparator: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationLeftContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationLoaderWrapper: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationMessagesIcon: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationNotificationsContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationNotificationsIcon: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationRightContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationRoot: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationSectionContainer: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationSectionLabel: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationSectionRightLabel: { 'aria-label': 'just a typescript test' },
  dsLeftnavigationVerticalSeparator: { 'aria-label': 'just a typescript test' },
};
const SlotPropsAsFunctions: DSLeftNavigationT.SlotFunctionArguments = {
  dsLeftnavigationAlertsIcon: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationAreasContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationArrowContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationBodyAreasContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationBodyHeaderArea: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationBodyItemsArea: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationBottomContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationCollapsedContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationExceptionsIcon: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationFooterItem: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationFooterLabel: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationFooterMenu: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationFooterMenuCollapse: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationFooterSeparator: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationHeaderArea: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItem: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItemBorderBottom: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItemChevronBack: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItemDate: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItemLabel: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationItemSeparator: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationLeftContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationLoaderWrapper: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationMessagesIcon: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationNotificationsContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationNotificationsIcon: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationRightContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationRoot: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationSectionContainer: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationSectionLabel: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationSectionRightLabel: () => ({ 'aria-label': 'just a typescript test' }),
  dsLeftnavigationVerticalSeparator: () => ({ 'aria-label': 'just a typescript test' }),
};
const EnsureAllSlotsExistInSlotFunctionArguments: Required<
  TypescriptHelpersT.PropsForSlots<typeof DSLeftNavigationName, typeof LEFT_NAVIGATION_SLOTS>
> = SlotPropsAsFunctions;
